/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { allergyList } from '../fn/allergy/allergy-list';
import { AllergyList$Params } from '../fn/allergy/allergy-list';
import { DataPageOfAllergy } from '../models/data-page-of-allergy';

@Injectable({ providedIn: 'root' })
export class AllergyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `allergyList()` */
  static readonly AllergyListPath = '/allergy/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allergyList()` instead.
   *
   * This method doesn't expect any request body.
   */
  allergyList$Response(params?: AllergyList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfAllergy>> {
    return allergyList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allergyList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allergyList(params?: AllergyList$Params, context?: HttpContext): Observable<DataPageOfAllergy> {
    return this.allergyList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfAllergy>): DataPageOfAllergy => r.body)
    );
  }

}
